<section class="big-screen">
  <section [@pixelateInOutDelay]="true" class="bottom-boxes bottom-boxes-bubble">
    @for (prompt of fileUploadResponse(); track prompt.key) {
      <div (click)="sendToMainEvent.emit(prompt.value)" class="bubble">
        <p [title]="prompt.key">{{ prompt.value }}</p>
      </div>
    }
  </section>
</section>

<section class="small-screen">
  <section [@pixelateInOutDelay]="true" class="small-bubbles">
    @for (prompt of fileUploadResponse(); track prompt.key) {
      <div (click)="sendToMainEvent.emit(prompt.value)" class="bubble p-4">
        <p [title]="prompt.key">{{ prompt.value }}</p>
      </div>
    }
  </section>
</section>
